import * as platform from './pdc-platform/src/ts/main';

import { config } from './pdc-platform/src/ts/config';
import { IGlob } from './pdc-platform/src/ts/Glob';
const customSignInForm = require('./customSignInForm');

declare var require: any;
var FieldModulesLoader = require('_common/platform/jsx/mixins/FieldModulesLoader');

FieldModulesLoader.addModules({
    '_common/platform/ts/NumberField': require('bundle-loader?lazy!_common/platform/ts/NumberField'),
    '_common/platform/ts/StringField': require('bundle-loader?lazy!_common/platform/ts/StringField'),
    '_common/platform/ts/ButtonField': require('bundle-loader?lazy!_common/platform/ts/ButtonField'),
    '_common/platform/ts/BooleanField': require('bundle-loader?lazy!_common/platform/ts/BooleanField'),
    '_common/platform/ts/CKEditField': require('bundle-loader?lazy!_common/platform/ts/CKEditField'),
    '_common/platform/ts/MultiField': require('bundle-loader?lazy!_common/platform/ts/MultiField'),
    '_common/platform/ts/ThemesListField': require('bundle-loader?lazy!_common/platform/ts/ThemesListField'),
    '_common/platform/ts/FolderSelectField': require('bundle-loader?lazy!_common/platform/ts/FolderSelectField'),
    '_common/platform/ts/SelectField': require('bundle-loader?lazy!_common/platform/ts/SelectField'),
    '_common/platform/ts/TimeZonesListField': require('bundle-loader?lazy!_common/platform/ts/TimeZonesListField'),
    '_common/platform/ts/CustomMenu': require('bundle-loader?lazy!_common/platform/tsx/CustomMenuField')
});

function customInitializer(glob: IGlob) {
    glob.customSignInForm = customSignInForm;
}
platform.init(document.getElementById('pdc-dashboard-container'), customInitializer);

declare var __webpack_public_path__: any;

__webpack_public_path__ = config.PUBLIC_PATH;
